import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Card from '../../components/cards/Card';
import Dropdown from '../../components/inputFields/DropDown';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import SearchBar from '../../components/searchBar/SearchBar';
import { getProducts } from '../../services/products';
import { toast } from 'react-toastify';
import { BiCopy, BiRefresh } from 'react-icons/bi';
import { GrGallery } from 'react-icons/gr';
import GalleryComponent from '../../components/GalleryComponent';
import { GoEye } from 'react-icons/go';
import { Link } from 'react-router-dom';


function PrimaryProducts() {
    const [cardData, setCardData] = useState([
        {
            title: "Total Products",
            count: "--",
        },
        {
            title: "Total Brands",
            count: "--",
        },
        {
            title: "Available Products",
            count: "--",
        },
        {
            title: "Out Of Stocks",
            count: "--",
        },
    ]);


    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "ID", key: "id" },
        { label: "Image", key: "image" },
        { label: "Name", key: "name" },
        { label: "Order", key: "order" },
        { label: "Category", key: "category" },
        { label: "Discount Percentage", key: "discount_percentage" },
        { label: "Manufacture", key: "manufacture" },
        { label: "MRP", key: "mrp" },
        { label: "Price", key: "price" },
        { label: "Shop", key: "shop" },
        { label: "Availability", key: "availability_status" },
        { label: "View", key: "view" },
    ];

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleBrandChange = (value) => {
        setFilterBrand(value);
        fetchData(`?search=${searchText}&availability_status${filterAvailability}`);
    };

    const handleAvailabilityChange = (value) => {
        setFilterAvailability(value);
        fetchData(`?search=${searchText}&availability_status${value}`);
    };

    const [searchText, setSearchText] = useState("");
    const [filterBrand, setFilterBrand] = useState("");
    const [filterAvailability, setFilterAvailability] = useState("");

    const pageSize = 10;

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData(`?search=${query}&availability_status${filterAvailability}`);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getProducts(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error in Manufacturers:", error);
        } finally {
            setLoading(false);
        }
    };

    const resetFilters = () => {
        setSearchText("");
        setFilterAvailability("");
        setFilterBrand("");
        fetchData("");
    };

    useEffect(() => {
        fetchData("");
    }, []);

    const copyClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                toast.success('Copied to clipboard!');
            })
            .catch(() => {
                toast.error('Failed to copy address');
            });
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Bazaar', },
            { name: 'Primary Products' },
        ]} />
        <div className="py-3">
            <StyledHeadingText text={"Products"} />
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.count} />
                ))}
            </div>
        </div>
        <div className="flex flex-row justify-between item-center">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 justify-center items-center max-w-4xl">
                <SearchBar placeholder="Search for Product/ SKU" onSearch={handleSearch} value={searchText} />
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 justify-center items-center">
                    {/* <Dropdown
                        name="status"
                        options={[
                            {
                                value: "Rashail",
                                label: "Rashail",
                            },
                            {
                                value: "Neptune",
                                label: "Neptune",
                            },
                            {
                                value: "Balwaan",
                                label: "Balwaan",
                            },
                        ]}
                        needSearch
                        placeholder="Brand"
                        onChange={handleBrandChange}
                    /> */}
                    <Dropdown
                        name="availability"
                        value={filterAvailability}
                        options={[
                            {
                                value: "In stock",
                                label: "IN_STOCK",
                            },
                            {
                                value: "Out of stock",
                                label: "OUT_OF_STOCK",
                            },
                            {
                                value: "Limited Stocks",
                                label: "LIMITED_STOCK",
                            },
                            {
                                value: "Preorder",
                                label: "PREORDER",
                            },
                            {
                                value: "Discontinued",
                                label: "DISCONTINUED",
                            },
                        ]}
                        placeholder="Availability"
                        onChange={handleAvailabilityChange}
                    />
                    {
                        searchText.length !== 0 || filterAvailability.length !== 0 ?
                            <BiRefresh size={24} className='cursor-pointer text-primary' onClick={resetFilters} /> : <></>
                    }
                </div>
            </div>
            {/* <Link className='self-center'>
                <Button
                    type="button"
                    className="hover:bg-black hover:opacity-70 text-white bg-black rounded-md"
                >
                    Add Product
                </Button>
            </Link> */}
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                id: <span className='flex flex-row gap-1 items-center'><p className="max-w-16 truncate cursor-help" title={item.id}>{item.id}</p> <BiCopy className='cursor-pointer' color='blue' onClick={() => { copyClipboard(item.id) }} /></span>,
                                name: <span className='flex flex-row gap-1 items-center'><p className="max-w-24 truncate cursor-help" title={item.product_name}>{item.product_name}</p> <BiCopy className='cursor-pointer' color='blue' onClick={() => { copyClipboard(item.product_name) }} /></span>,
                                image: <GalleryComponent openingComponent={item.images.length > 0 ? <img src={item.images[0]} className="rounded-sm aspect-square max-h-12" /> : <p>-</p>} className='rounded-full aspect-square max-w-28 border border-primary' images={item.images} />,
                                order: <p>{item.order}</p>,
                                category: <p>{item.category}</p>,
                                discount_percentage: <p>{item.discount_percentage}</p>,
                                manufacture: <p>{item.manufacture}</p>,
                                mrp: <p>₹{item.mrp}</p>,
                                price: <p>₹{item.price}</p>,
                                shop: <p>{item.shop}</p>,
                                availability_status: <p>{item.availability_status}</p>,
                                view: <Link to={`/bazzar/products/${item.slug}/`}> <GoEye size={20} /> </Link>,
                            }))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}
                    
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                /> : <></>
        }
    </>);
}

export default PrimaryProducts;